import React, { useEffect, useState } from "react";
// import MasterLayout from "../../masterLayout/MasterLayout";
import MasterLayout from "../masterLayout/MasterLayout";
// import Breadcrumb from "../../components/Breadcrumb";
import Breadcrumb from "../components/Breadcrumb";
import axios from "axios";
// import { BaseUrl } from "../../helper/apiHelper";
import { Icon } from "@iconify/react/dist/iconify.js";
import toast from "react-hot-toast";
import { createBlogCategoryApi, createBlogTagsApi, deleteBlogcategoryApi, deleteBlogTagsApi, getBlogCategoriesApi, getBlogTagsApi, getContactInquiryAPi } from "../helper/api_helper";
const ContactInquiry = () => {
    const [guards, setGuards] = useState([]);
    const [categories, setCategories] = useState([]);
    const [showAddGuardModal, setShowAddGuardModal] = useState(false);
    const [newGuard, setNewGuard] = useState({ categoryName: '', id: '', message: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [isEditing, setIsEditing] = useState(false); // Track edit mode
    const [searchTerm, setSearchTerm] = useState("");

    const handleCreateOrUpdateGuard = async () => {
        const { categoryName, id } = newGuard;

        // if (!categoryName) {
        //     toast.error("Please fill all fields");
        //     return;
        // }

        if (!categoryName) {
            toast.error("Please fill all fields");
            return;
        }


        try {
            setIsLoading(true);

            if (isEditing) {


                const response = await createBlogTagsApi({
                    tag_name: categoryName,
                    id: id,
                })




                toast.success("Tag updated successfully!");
            } else {


                await createBlogTagsApi({
                    tag_name: categoryName,

                })
                toast.success("Tag created successfully!");
            }

            setShowAddGuardModal(false);
            setNewGuard({ categoryName: '', id: '' });
            setIsEditing(false);
            getAllBlogCategories(); // Refresh list
        } catch (error) {
            toast.error(error || "Action failed");
        } finally {
            setIsLoading(false);
        }
    };

    const handleGuardChange = (e) => {
        const { name, value } = e.target;
        setNewGuard((prev) => ({ ...prev, [name]: value }));
    };

    const [isLoading, setIsLoading] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(false);

    const getAllBlogCategories = async () => {
        try {
            setIsPageLoading(true);
            const response = await getContactInquiryAPi();

            setCategories(response.data);

        } catch (error) {

            toast.error("Failed to fetch categories");
            setCategories([]);
        } finally {
            setIsPageLoading(false);
        }
    };

    useEffect(() => {
        getAllBlogCategories();
    }, []);
    const handleEditClick = async (item) => {
        

    }
    const handleDeleteClick = async (item) => {
        const toastId = toast.loading("Deleting Tag...");
        try {

            let body = { id: item.id }
            let response = await deleteBlogTagsApi(body);
            // if (response.status === 200) {
            toast.success("Tag deleted successfully", { id: toastId })
            getAllBlogCategories()
            // }
        } catch (error) {
            toast.error(error || "Something went wrong", { id: toastId });

        }
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    const filteredBooking = categories?.filter((categories) => {
        const search = searchTerm?.toLowerCase();

        return Object.entries(categories)
            .filter(([key]) =>
                ["fullname"].includes(key)
            )
            .some(([_, value]) =>
                String(value)?.toLowerCase().includes(search)
            );
    });


    const [currentPage, setCurrentPage] = useState(1);

    const [itemsPerPage] = useState(10);
    const totalItems = categories?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <MasterLayout>
            <Breadcrumb title="Contact Inquiry" />

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
                        <form className="navbar-search d-flex align-items-center gap-2">
                            <input
                                type="text"
                                className="bg-base h-40-px w-auto form-control"
                                name="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>



                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            {isPageLoading ? (
                                <div className="text-center py-40">
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            ) : filteredBooking?.length === 0 ? (
                                <div className="text-center py-40 text-muted fw-medium">No Contact Inquiry found.</div>
                            ) : (
                                <table className="table basic-border-table mb-0">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Full Name</th>
                                            <th>Country</th>

                                            <th>Mobile Number</th>

                                            <th>Email</th>
                                            <th>Type Of Query</th>



                                            {/* <th>Email</th> */}
                                            <th>Message</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredBooking?.slice(startIdx, startIdx + itemsPerPage)?.map((items, index) => (



                                            <tr key={index}>
                                                <td>{formatDate(items.createdAt)}</td>

                                                <td>{items.fullname}</td>
                                                <td>{items.country}</td>

                                                <td>{items.phone_number}</td>

                                                <td>{items.email}</td>
                                                <td>{items.type_of_query}</td>

                                                <td className="text-center">
                                                    <div className="d-flex align-items-start gap-10 justify-content-start">
                                                        {/* <button
                                                            type="button"
                                                            className="bg-info-focus text-info-600 bg-hover-info-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                            onClick={() => {
                                                                setIsEditing(true); 
                                                                setShowAddGuardModal(true);
                                                                setNewGuard({
                                                                    categoryName: items.tag_name,
                                                                    id: items.id,
                                                                });
                                                            }}
                                                        >
                                                            <Icon icon="lucide:eye" className="menu-icon" />
                                                        </button> */}

                                                        <button
                                                            type="button"
                                                            className="bg-info-focus text-info-600 bg-hover-info-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                            onClick={() => {
                                                                setIsEditing(true);
                                                                setShowAddGuardModal(true);
                                                                setNewGuard({
                                                                    categoryName: items.tag_name,
                                                                    id: items.id,
                                                                    message: items.message, // pass the message
                                                                });
                                                            }}
                                                        >
                                                            <Icon icon="lucide:eye" className="menu-icon" />
                                                        </button>

                                                    </div>

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        {filteredBooking?.length > itemsPerPage &&


                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24 mb-10">
                                <span>
                                    Showing {startIdx + 1} to{" "}
                                    {Math.min(startIdx + itemsPerPage, filteredBooking?.length)} of{" "}
                                    {filteredBooking?.length} entries
                                </span>
                                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                                    <li className="page-item">
                                        <button
                                            className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                            onClick={() => goToPage(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            <Icon icon="ep:d-arrow-left" className="text-xl" />
                                        </button>
                                    </li>

                                    {[...Array(totalPages)].map((_, index) => (
                                        <li className="page-item" key={index}>
                                            <button
                                                className={`page-link ${currentPage === index + 1
                                                    ? "bg-primary-600 text-white"
                                                    : "bg-primary-50 text-secondary-light"
                                                    } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                                                onClick={() => goToPage(index + 1)}
                                            >
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}

                                    <li className="page-item">
                                        <button
                                            className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                            onClick={() => goToPage(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            <Icon icon="ep:d-arrow-right" className="text-xl" />
                                        </button>
                                    </li>
                                </ul>
                            </div>}


                    </div>
                </div>
                {/* card end */}
            </div>


            {showAddGuardModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div className="modal-dialog modal-md modal-dialog-centered" style={{ zIndex: 11122 }}>
                            <div className="modal-content radius-16 bg-base">
                                <div className="modal-header py-16 px-24 border-bottom">
                                    <h1 className="modal-title fs-5">
                                        {isEditing ? "View Message" : "Add Tag"}
                                    </h1>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowAddGuardModal(false)}
                                    />
                                </div>

                                <div className="modal-body p-24">
                                    <form className="row g-3">
                                        <div className="col-12">
                                            {/* <label className="form-label fw-medium">Message</label> */}
                                            <div className="border p-3 rounded text-muted bg-light">
                                                {newGuard?.message || 'No message available.'}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />
                    </div>
                </>
            )}


        </MasterLayout>
    );
};

export default ContactInquiry;
